import { Reset } from '.';
import { GrFormClose } from 'react-icons/gr';

const FilterHeader = ({ setData, closeFilter }) => {
    return (
        <div className="op-sidebar__top">
            <span className="op-sidebar__title">Filter</span>
            <span className="op-sidebar__actions">
                <button type="button" className="op-sidebar__reset-btn">
                    <Reset setData={setData} />
                </button>

                <button
                    type="button"
                    className={`op-sidebar__close-btn`}
                    onClick={closeFilter}
                >
                    <GrFormClose />
                </button>
            </span>
        </div>
    );
};

export default FilterHeader;
